import { render, staticRenderFns } from "./wdIndex.vue?vue&type=template&id=121ef752&scoped=true&"
import script from "./wdIndex.vue?vue&type=script&lang=js&"
export * from "./wdIndex.vue?vue&type=script&lang=js&"
import style0 from "./wdIndex.vue?vue&type=style&index=0&id=121ef752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ef752",
  null
  
)

export default component.exports